import styled from 'styled-components'

export const Summary = styled.section`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 26px;
  padding: 14px 18px;
  border: 1px solid ${({ theme }) => theme.palette.colors.cardBorder};
  border-radius: 12px;
  background: ${({ theme }) => theme.palette.colors.summarySurface};
`;
export const Metric = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: max-content;
`;
export const MetricValue = styled.strong`
  color: ${({ theme }) => theme.palette.colors.text};
  font-family: Gilroy, sans-serif;
  font-size: 20px;
`;
export const MetricLabel = styled.span`
  color: ${({ theme }) => theme.palette.colors.muted};
  font-family: Lato, sans-serif;
  font-size: 13px;
`;
